import axios from 'axios'

const state = {
    preview: null,
    anewitem: null,
    sellings: null,
    buyings: null,
    modifyItem: null,
    oldPaymentLinks: null,
    showModifyItemPhotos: true,
}

const getters = {
    preview (state) {
        return state.preview
    },
    anewitem (state) {
        return state.anewitem
    },
    sellings (state) {
        return state.sellings
    },
    buyings (state) {
        return state.buyings
    },
    modifyItem (state) {
        return state.modifyItem
    },
    oldPaymentLinks (state) {
        return state.oldPaymentLinks
    },
    showModifyItemPhotos (state) {
        return state.showModifyItemPhotos
    }
    // console.log(Object.assign({}, activeUser))
}

const actions = {
    async photosPreview({ commit }, photosArr) {
        if(photosArr.length > 0){   
            return commit('SET_PREVIEW', photosArr)
        }
    },
    
    async buildNewItemObj({ commit, getters }, newItemObj) { 
        if(newItemObj !== null){  
            // get the current content of state.anewitem then append this new values to it
            let occupantObj = getters.anewitem
            let incomingObj = newItemObj
            let combinedObj = {...occupantObj, ...incomingObj}
            return commit('SET_ANEWITEM', combinedObj)
        }
    },
    
    async modifyItemObj({ commit, getters }, itemObj) { 
        if(itemObj !== null){  
            // get the current content of state.modifyItem then append this new values to it
            let occupantObj = getters.modifyItem
            let incomingObj = itemObj
            let combinedObj = {...occupantObj, ...incomingObj}
            return commit('MODIFY_ITEM', combinedObj)
        }
    },
    
    async destroyNewItemObj({ commit }) { 
        // flush the state contents of preview and anewitem
        commit('SET_PREVIEW', null)
        return commit('SET_ANEWITEM', null)
    },

    async postaNewItem({ dispatch }, anewitemObj) {
        let formData = new FormData();
        // loop through the anewitemObj and append each key to the value.
        for (const anewitemKey in anewitemObj) {
            if (anewitemObj.hasOwnProperty(anewitemKey)) {
                const anewitemVal = anewitemObj[anewitemKey];
                formData.append(anewitemKey, anewitemVal)
            }
        }
        // append each uploaded photo as a file array hence anewitemObj.photos[x].path[x]
        for(let x=0; x < anewitemObj.photos.length; x++){
            formData.append('photos', anewitemObj.photos[x].path[x])
            formData.append('main', anewitemObj.photos[x].main)
        }
        let response = await axios.post(`/items/anewitem`, formData)
        if(!response.data.error){
            dispatch('itemsIamSelling', anewitemObj)
        }
        return response.data
    },
    
    async addMoreItemPhotos({ dispatch }, itemObj) {
        let formData = new FormData();
        // loop through the itemObj and append each key to the value.
        for (const itemKey in itemObj) {
            if (itemObj.hasOwnProperty(itemKey)) {
                const itemVal = itemObj[itemKey];
                formData.append(itemKey, itemVal)
            }
        }
        // append each uploaded photo as a file array hence itemObj.photos[x].path[x]
        for(let x=0; x < itemObj.photos.length; x++){
            formData.append('photos', itemObj.photos[x].path[x])
        }
        let response = await axios.post(`/items/updateItemPhotos`, formData)
        if(response.data !== null){
            dispatch('modifyItemObj', response.data.result)
            return response.data
        }
    },

    async toggleModifyItemPhotos({ commit }, val) { 
        if(val == '') { val = false }
        return commit('SHOW_MODIFY_ITEM_PHOTOS', val)
    },
    
    async saveModifiedItem({ dispatch }, itemObj) {
        let response = await axios.put(`/items/updateItem`, itemObj)
        if(response.data !== null){
            dispatch('modifyItemObj', response.data.result)
            return response.data
        }
    },
    
    async itemsIamSelling({ commit, getters }) {
        let userObj = {
            userId: getters.user._id
        }
        let response = await axios.post('/items/showItemsIamSelling', userObj)
        if(response.data !== null){
            commit('MY_SELLINGS', response.data.result)
        }
        return response.data
    },
    
    async itemsIamBuying({ commit, getters }) {
        let userObj = {
            buyerId: getters.user._id
        }
        let response = await axios.post('/cart/showMyCart', userObj)
        if(!response.data.error){
            return commit('MY_BUYINGS', response.data.result)
        }
    },
    
    async removeBuyingItem({ dispatch, commit }, itemObj) {
        let response = await axios.post('/cart/removeCartItem', itemObj)
        if(!response.data.error){
            // empty my buying cart completely. then refetch them by running itemsIamBuying
            commit('MY_BUYINGS', null)
            return dispatch('itemsIamBuying')
        }
    },
    
    async markAnItemAsSold({ dispatch }, itemObj) {
        let response = await axios.post('/cart/markItemAsSold', itemObj)
        if(!response.data.error){
            return dispatch('itemsIamSelling')
        }
    },
    
    async hideItem({ dispatch }, itemObj) {
        let response = await axios.put('/items/hideAnItem', itemObj)
        if(!response.data.error){
            dispatch('modifyItemObj', response.data.result)
            dispatch('itemsIamSelling')
        }
        if(response.data){ return response.data }
    },
    
    async unhideItem({ dispatch }, itemObj) {
        let response = await axios.put('/items/unhideAnItem', itemObj)
        if(!response.data.error){
            dispatch('modifyItemObj', response.data.result)
            dispatch('itemsIamSelling')
        }
        if(response.data){ return response.data }
    },
    
    async removeItem({ dispatch, commit }, itemObj) {
        let response = await axios.post('/items/deleteAnItem', itemObj)
        if(!response.data.error){ 
            // empty my selling items completely. then refetch them by running itemsIamSelling
            commit('MY_SELLINGS', null)
            dispatch('itemsIamSelling') 
        }
        if(response.data){ return response.data }
    },
    
    async generatePayLink({ _ }, itemObj) {
        let response = await axios.post('/payments/oneTimePayment', itemObj)
        return response.data
    },
    
    async fetchPaymentLinks({ commit }, itemObj) {
        commit('OLD_PAYMENT_LINKS', null)
        let response = await axios.post('/payments/olderPaymentLinks', itemObj)
        if(!response.data.error){ 
            return commit('OLD_PAYMENT_LINKS', response.data.result)
        }
        return response.data
    },

    async deleteOldPayLink({ dispatch }, linkObj) {
        let response = await axios.post('/payments/removeOldPayLink', linkObj)
        if(!response.data.error){
            dispatch('fetchPaymentLinks', linkObj)
        }
        return response.data
    },
}

const mutations = {
    SET_PREVIEW: (state, preview) => (state.preview = preview),
    SET_ANEWITEM: (state, anewitem) => (state.anewitem = anewitem),
    MY_SELLINGS: (state, sellings) => (state.sellings = sellings),
    MY_BUYINGS: (state, buyings) => (state.buyings = buyings),
    MODIFY_ITEM: (state, modifyItem) => (state.modifyItem = modifyItem),
    OLD_PAYMENT_LINKS: (state, oldPaymentLinks) => (state.oldPaymentLinks = oldPaymentLinks),
    SHOW_MODIFY_ITEM_PHOTOS: (state, val) => (state.showModifyItemPhotos = val)
}

export default {
    state,
    getters,
    actions,
    mutations
}